<template>
  <div class="">
    <!-- 查询表单 -->
    <div>
      <el-form
        ref="expressFundDetailForm"
        :model="expressFundDetailForm"
        label-width="80px"
      >
      <el-row>
        <el-col :span="2.5">
              <el-form-item label="查询时间">
                <el-date-picker clearable
                                v-model="expressFundDetailForm.rangeTime"
                                type="daterange"
                                align="right"
                                unlink-panels
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd"
                                :picker-options="pickerOptions1"
                               >
                </el-date-picker>
              </el-form-item>
            </el-col>
          <el-col :span="2.5">
            <el-button type="primary" @click="getListSearchExpressFundDetail">查询</el-button>
            <el-button type="primary" style="margin-left:6px" @click="exportExcelData">批量导出</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div style="margin-top: 20px;">
      <!-- 表格 -->
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="typeName" label="类型"> </el-table-column>
        <el-table-column prop="deliverOrderNo" label="发货单号"> </el-table-column>
        <el-table-column prop="amount" label="金额（元）"> </el-table-column>
        <el-table-column prop="time" label="时间"> </el-table-column>
        <el-table-column prop="statusName" label="结算状态"></el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        style="margin-top: 20px;"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 40, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="tableTotal"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  props: {},
  data() {
    return {
      // 查询数据
      expressFundDetailForm: {
        rangeTime:[new Date(Date.now() - 29 * 24 * 60 * 60 * 1000).toISOString().slice(0,10), new Date().toISOString().slice(0,10)],
      },
      // 表格数据
      tableTotal: 0,
      tableData: [],
      pageSize: 100,
      currentPage: 0,
    };
  },
  watch: {},
  computed: {},
  methods: {
     //限制
     pickerOptions1: {
        onPick: (obj) => {
          this.pickerMinDate = new Date(obj.minDate).getTime();
          console.log(obj)
        },
        disabledDate: (time) => {
          if (this.pickerMinDate) {
            const day1 = 30 * 24 * 3600 * 1000
            let maxTime = this.pickerMinDate + day1
            let minTime = this.pickerMinDate - day1
            return time.getTime() > maxTime || time.getTime() < minTime || time.getTime() > Date.now()
          } else {
            return time.getTime() > Date.now()
          }

        }
      },
    // click事件
    exportExcelData () {
      let self = this
      self.$api
        .listSearchAhsExpressFundDetail({
          page: self.currentPage,
          size: 100,
          startDate: self.expressFundDetailForm.rangeTime instanceof Array && self.expressFundDetailForm.rangeTime.length > 1 ? self.expressFundDetailForm.rangeTime[0] : null,
          endDate: self.expressFundDetailForm.rangeTime instanceof Array && self.expressFundDetailForm.rangeTime.length > 1 ? self.expressFundDetailForm.rangeTime[1]: null,
        })
        .then((res) => {
          var downLoadTableData = res.data.records || [];
          require.ensure([], () => {
                const { export_json_to_excel } = require("@/vender/Export2Excel");
                const fieldName = ["类型", "发货单号","金额（元）","时间","结算状态"];
                const filterVal = ["typeName", "deliverOrderNo", "amount", "time", "statusName"];
                const data = downLoadTableData.map(v => filterVal.map(j => v[j]));
                export_json_to_excel(fieldName, data, "爱回收物流资金明细"+self.$moment(new Date()).format("YYYYMMDDHH:mm:ss"));
              });
        });
    },
    // 分页函数
    handleSizeChange(val) {
      console.log(val);
      this.pageSize = val;
      // 每次调整pagesize后，跳回第一页，保证有数据及请求不会报错
      this.handleCurrentChange(1);
    },
    handleCurrentChange(val) {
      this.currentPage = val;

      // 重新请求表格数据
      this.getListSearchExpressFundDetail();
    },

    // 获取表格数据
    getListSearchExpressFundDetail() {
      let self = this;
      self.$api
        .listSearchAhsExpressFundDetail({
          page: self.currentPage,
          size: 100,
          startDate: self.expressFundDetailForm.rangeTime instanceof Array && self.expressFundDetailForm.rangeTime.length > 1 ? self.expressFundDetailForm.rangeTime[0] : null,
          endDate: self.expressFundDetailForm.rangeTime instanceof Array && self.expressFundDetailForm.rangeTime.length > 1 ? self.expressFundDetailForm.rangeTime[1]: null,
        })
        .then((res) => {
          self.tableData = res.data.records || [];
          self.tableTotal = res.data.total;
        });
    },
  },
  created() {},
  mounted() {
    let self = this;
    self.getListSearchExpressFundDetail();
  },
};
</script>
<style lang="less" scoped></style>
